import { css as e, keyframes as t, styled as n } from "styled-components";
import { ILL_EASING as r, ILL_ENTER as i, ILL_KEYFRAME as a, ILL_MOTION as o } from "@maat/assets";
//#region src/components/Illustration/Illustration.styled.ts
var s = {
	sway: t`
    0%, 100% { transform: rotate(-3deg); }
    50% { transform: rotate(3deg); }
`,
	leaf: t`
    0%, 100% { transform: rotate(-2.5deg); }
    50% { transform: rotate(2.5deg); }
`,
	steam: t`
    0% { opacity: 0; transform: translateY(3px) scaleX(0.85); }
    20% { opacity: 0.55; }
    65% { opacity: 0.2; }
    100% { opacity: 0; transform: translateY(-13px) scaleX(1.3); }
`,
	write: t`
    0%, 100% { transform: translate(-3px, 0) rotate(0); }
    25% { transform: translate(0, -1.2px) rotate(2.5deg); }
    50% { transform: translate(3px, 0) rotate(0); }
    75% { transform: translate(0, -1.2px) rotate(-2.5deg); }
`,
	ink: t`
    0% { stroke-dashoffset: 30; opacity: 1; }
    55% { stroke-dashoffset: 0; }
    88% { stroke-dashoffset: 0; opacity: 1; }
    100% { stroke-dashoffset: 0; opacity: 0; }
`,
	ring: t`
    0%, 70%, 100% { transform: rotate(0); }
    77% { transform: rotate(7deg); }
    84% { transform: rotate(-6deg); }
    90% { transform: rotate(3deg); }
    95% { transform: rotate(-1.5deg); }
`,
	pulse: t`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.14); }
`,
	bob: t`
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-2.2px); }
`,
	type: t`
    0%, 100% { opacity: 0.75; }
    50% { opacity: 0.3; }
`,
	twinkle: t`
    0%, 100% { transform: scale(1); }
    45% { transform: scale(1.22); }
`,
	grow: t`
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(1.07); }
`,
	fade: t`
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
`,
	tilt: t`
    0%, 100% { transform: rotate(-1.1deg); }
    50% { transform: rotate(1.1deg); }
`,
	drift: t`
    0%, 100% { transform: translate(0, 0); }
    33% { transform: translate(2.5px, -1.5px); }
    66% { transform: translate(-2px, 1.5px); }
`
}, c = (e) => `cubic-bezier(${r[e].join(",")})`, l = {
	fade: t`
    from { opacity: 0; transform: scale(0.965); }
    to { opacity: 1; transform: none; }
`,
	widen: t`
    from { opacity: 0; transform: scaleX(0.35); }
    to { opacity: 1; transform: none; }
`,
	rise: t`
    from { opacity: 0; transform: translateY(18px); }
    to { opacity: 1; transform: none; }
`,
	riseS: t`
    from { opacity: 0; transform: translateY(9px); }
    to { opacity: 1; transform: none; }
`,
	drop: t`
    from { opacity: 0; transform: translateY(-22px); }
    to { opacity: 1; transform: none; }
`,
	pop: t`
    from { opacity: 0; transform: scale(0.4); }
    to { opacity: 1; transform: none; }
`,
	inL: t`
    from { opacity: 0; transform: translateX(-20px); }
    to { opacity: 1; transform: none; }
`,
	inR: t`
    from { opacity: 0; transform: translateX(20px); }
    to { opacity: 1; transform: none; }
`
}, u = Object.keys(o).map((t) => {
	let { duration: n, delay: r = 0, easing: i, reverse: c } = o[t];
	return e`
        .a-${t} {
            animation: ${s[a[t]]} ${n}ms ${i === "out" ? "ease-out" : "ease-in-out"}
                ${r}ms infinite ${c ? "reverse" : ""};
        }
    `;
}), d = Object.keys(i).map((t) => {
	let { dur: n, easing: r } = i[t];
	return e`
        .p-${t} {
            animation: ${l[t]} var(--d, ${n}ms) ${c(r)} var(--t, 0ms) both;
        }
    `;
}), f = n.svg`
    display: block;
    flex-shrink: 0;

    /* Added on mount, removed once the sequence lands — after which this is static
       SVG. Widget scenes carry no entrance, so for them this class does nothing. */
    &.pl {
        ${d}
    }

    &.mo {
        ${u}
    }

    /* The resting frame is already the artwork, so there is nothing to substitute —
       everything simply stops. */
    @media (prefers-reduced-motion: reduce) {
        * {
            animation: none !important;
        }
    }
`, p = n(f)`
    max-width: 100%;
    height: auto;
`;
//#endregion
export { f as IllustrationSvg, p as PageIllustrationSvg };
